import React, { Fragment } from 'react'

import { Box, Flex, InputGroup } from '@clear/design-system'
import { useForm } from 'react-hook-form'
import { Form, StepSubTitle } from '@components/layout/Form'
import { yupResolver } from '@hookform/resolvers/yup'
import PageContent from './layout/PageContent'
import { ContinueButton } from './FormButtons'
import { authSchemaWithoutTerms } from '@validators/schema/enroll/authSchema'

interface SelectVerificationMethodFormProps {
  formData?: {
    email?: string
    phoneNumber?: string
  }
  onSubmitData: (formData) => void
}

const SelectVerificationMethodForm: React.FC<SelectVerificationMethodFormProps> =
  ({ onSubmitData }) => {
    const { register, handleSubmit, formState } = useForm<any>({
      resolver: yupResolver(authSchemaWithoutTerms),
      mode: 'onChange',
      defaultValues: {
        countryCode: '+1',
      },
    })
    const { errors } = formState

    async function onSubmit(formData: any) {
      onSubmitData(formData)
    }

    return (
      <PageContent>
        <Box
          width={['95%', '572px']}
          marginLeft="auto"
          marginRight="auto"
          border="1px solid #CCCED1"
          borderRadius="8px"
          paddingX={['20px', '50px']}
          paddingY={['20px', '40px']}
          backgroundColor="neutralsWhite"
        >
          <Fragment>
            <Box
              className="pb-4 px-4"
              as="img"
              minWidth={0}
              mx="auto"
              src="/tsa-pre-logo-auth.svg"
              alt="TSA pre-check with CLEAR logo"
            />

            <StepSubTitle textAlign="center" fontSize={3}>
              Enter your email and mobile number. You'll be sent a one-time code
              to sign in / create an account
            </StepSubTitle>

            <Form onSubmit={handleSubmit(onSubmit)}>
              <InputGroup
                data-cy="email"
                placeholder={'Email'}
                mb={2}
                {...register('email')}
                error={errors.email?.message}
                containerProps={{ padding: 0 }}
              />

              <Flex flexDirection="row">
                <InputGroup
                  data-cy={'countryCode'}
                  name="countryCode"
                  disabled
                  value="+1"
                  containerProps={{
                    padding: 0,
                    width: '20%',
                  }}
                />

                <InputGroup
                  data-cy="phoneNumber"
                  placeholder={'Phone number'}
                  {...register('phoneNumber')}
                  error={errors.phoneNumber?.message}
                  containerProps={{
                    padding: 0,
                    marginLeft: '10px',
                    width: '90%',
                  }}
                />
              </Flex>

              <ContinueButton marginTop="15px" type="submit" />
            </Form>
          </Fragment>
        </Box>
      </PageContent>
    )
  }

export default SelectVerificationMethodForm
